<template>
    <div class="register-view">
        <div class="texts">
            <h1>Зарегистрировать</h1>
            <p>Создайте бесплатную учетную запись</p>
        </div>

        <form @submit.prevent="register">
            <input v-model="username" placeholder="Имя пользователя" required />
            <input v-model="email" type="email" placeholder="Электронная почта" required />
            <input v-model="password" type="password" placeholder="Пароль" required />
            <button type="submit" class="w-100 primary">Зарегистрировать</button>
        </form>

        <p class="login">
            Уже есть аккаунт?
            <router-link to="/auth/login">Авторизоваться</router-link>
        </p>
    </div>
</template>

<script>
export default {
    name: 'RegisterView',
    data() {
        return {
            username: '',
            email: '',
            password: '',
        };
    },
    methods: {
        async register() {
            try {
                await this.$api.register(this.username, this.email, this.password);
                this.$router.push({ name: 'HomeChat' });
                this.$snackbar.add({
                    type: 'success',
                    text: 'Successfully registered'
                });
            } catch (err) {
                let errorMessage;

                if (err.name === 'ValidationError') {
                    // Handle client-side validation errors
                    errorMessage = Object.values(err.errors).join('\n');
                } else if (err.details) {
                    // Handle server-side validation errors
                    if (err.details.message) {
                        errorMessage = err.details.message;
                    } else {
                        errorMessage = 'Registration failed';
                    }
                } else {
                    errorMessage = 'Registration failed';
                }

                this.$snackbar.add({
                    type: 'error',
                    text: errorMessage
                });

                console.error('Registration error:', err);
            }
        }
    },
};
</script>

<style scoped>
.texts {
    text-align: center;
    margin-bottom: 30px;
}

.texts p {
    margin-top: 4px;
    color: var(--color-text-light);
}

.register-view {
    max-width: 400px;
    margin: 100px auto;
    padding: 40px 30px;
    background-color: var(--color-secondary);
    border: 1px solid var(--color-border);
    border-radius: var(--default-border-radius);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

input {
    display: block;
    width: 100%;
    margin-bottom: 8px;
    padding: 12px 20px;
    color: var(--color-text);
    border: 1px solid var(--color-border);
    background-color: var(--background-color);
    border-radius: var(--default-border-radius);
}

input:focus {
    outline: none;
    border-color: var(--color-primary);
}

button {
    margin-top: 20px;
}

.error {
    color: red;
    text-align: center;
}

.login {
    margin-top: 20px;
    text-align: center;
    font-size: 14px;
}
</style>
